import Navigation from '@App/navigation'

const getCatalogPath = (isComplete: boolean, rightsHolderId: number, id: number): string =>
    isComplete
        ? Navigation.rightholder.catalog.work(rightsHolderId, id as number)
        : Navigation.rightholder.registrationDrafts.draft(rightsHolderId, id as number)

export default getCatalogPath
